import { clipAccessLabel } from "./clipAccess";

/** همان منطق badge دسترسی در لیست کلیپ‌ها. */
export function getClipCatalogAccessProps(clip) {
	const isFree = clip?.access_type === "free";
	const accessLabel = isFree ? "رایگان" : clipAccessLabel(clip);
	return {
		accessBadgeText: accessLabel || undefined,
		accessUnlocked: isFree ? true : Boolean(clip?.can_watch),
	};
}
